import { SessionService } from "./../shared/services/session.service";
import { Component, OnInit, Inject, forwardRef } from "@angular/core";
import { MatDialog, MatInputModule, MatSnackBar } from "@angular/material";
import { RegistrationComponent } from "../registration/registration.component";
import { BackendApiService } from "../shared/services/backend-api.service";
import { User } from "../shared/class/user";
import { NgForm } from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material";
import { DOCUMENT } from "@angular/platform-browser";
import { AppComponent } from "../app.component";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  newuser: User;
  email: any;
  emailId: any;
  name: String;
  password: any;
  forgotPasswordClick: boolean;
  otpView: boolean;
  loginView: boolean;
  otp: any;
  deviceType: any;
  response: any;
  verify: boolean;
  callFrom: string;
  spinnerHidden: boolean = true;

  constructor(
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private backendApiService: BackendApiService,
    private sessionService: SessionService,
    private user: User,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(DOCUMENT) private document: any,
    @Inject(forwardRef(() => AppComponent)) private _parent: AppComponent
  ) {}

  openDialogSignUp() {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(RegistrationComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  onClickForgotPassword() {
    this.forgotPasswordClick = true;
    this.otpView = false;
    this.loginView = false;
  }

  forgotpassword(emailId) {
    if (!emailId.emailId) {
      this.snackBar.open("Please enter email id ", "", {
        duration: 2000,
      });
    } else {
      this.spinnerHidden = false;
      this.emailId = emailId.emailId;

      const inputData = {
        emailId: emailId.emailId,
      };

      this.backendApiService
        .postRawRequest("forgot_password", inputData)
        .subscribe(
          (res: any) => {
            this.spinnerHidden = true;
            this.otpView = true;
            this.forgotPasswordClick = false;
            this.loginView = false;
          },
          (error) => {
            this.spinnerHidden = true;
            this.snackBar.open(
              new DOMParser()
                .parseFromString(error.error, "text/html")
                .getElementsByTagName("p")[1]
                .textContent.replace("message", ""),
              "",
              {
                duration: 2000,
                verticalPosition: "top",
                horizontalPosition: "center",
                direction: "ltr",
              }
            );
          }
        );
    }
  }

  restpassword(form: NgForm) {
    if (form.valid) {
      this.spinnerHidden = false;
      console.log("reset");
      const inputData = {
        emailId: this.emailId,
        newPwd: form.value.resetpassword,
      };

      this.backendApiService
        .postRawRequest("update_password", inputData)
        .subscribe(
          (res: any) => {
            this.spinnerHidden = true;

            if (res.responseCode === "SC101") {
              this.snackBar.open("Password reset successfully ", "", {
                duration: 2000,
              });

              this.loginView = true;
              this.forgotPasswordClick = false;
              this.otpView = false;
              this.verify = false;
            } else if (res.responseCode === "FC101") {
              this.snackBar.open("Something went wrong", "", {
                duration: 2000,
              });
            } else {
              this.snackBar.open("Login failed", "", {
                duration: 3000,
              });
            }
          },
          (error) => {
            this.spinnerHidden = true;
            this.snackBar.open(
              new DOMParser()
                .parseFromString(error.error, "text/html")
                .getElementsByTagName("p")[1]
                .textContent.replace("message", ""),
              "",
              {
                duration: 2000,
                verticalPosition: "top",
                horizontalPosition: "center",
                direction: "ltr",
              }
            );
          }
        );
    }
  }
  goToUrl(): void {
    console.log(this.document);
  }

  //Login method
  SignIn() {
    this.spinnerHidden = false;
    const requestData = {
      deviceid: "",
      macId: "",
      uuid: "fc36fe3e-8f50-3cc4-82c5-d189fcfc9278",
      drmStatus: "",
      deviceType: 6,
      friendlyName: "dgfdhdf",
      notificationId: "",
      emailId: this.email,
      password: this.password,
    };

    this.backendApiService
      .postRawRequest("open_sign_in", requestData)
      .subscribe(
        (response: any) => {
          this.spinnerHidden = true;
          if (response.responseCode === "SC101") {
            this.newuser = new User();
            this.newuser = response.userDetails;
            this.newuser.loginStatus = true;
            this.sessionService.setData(this.newuser);
            if (response.token)
              this.sessionService.setUsertoken(response.token);
            this.snackBar.open("Successfully signed in", "", {
              duration: 2000,
            });

            // if(this.data.from === 'package'){
            //   this.user = this.sessionService.getData();
            //   this.dialog.closeAll();

            //   this._parent.getPackageList();

            // }else{
            setTimeout(() => {
              location.reload();
            }, 2000);

            // }
          } else if (response.responseCode != "SC101") {
            this.snackBar.open(response.message, "", {
              duration: 2000,
            });
          } else {
            this.snackBar.open("Login failed", "", {
              duration: 3000,
            });
          }
        },
        (error) => {
          this.spinnerHidden = true;
          this.snackBar.open(
            new DOMParser()
              .parseFromString(error.error, "text/html")
              .getElementsByTagName("p")[1]
              .textContent.replace("message", ""),
            "",
            {
              duration: 2000,
              verticalPosition: "top",
              horizontalPosition: "center",
              direction: "ltr",
            }
          );
        }
      );
  }

  onOTPCheck(form: NgForm): void {
    if (form.valid) {
      this.spinnerHidden = false;
      this.otp = form.value.otp;
      const otptype = "emailOtpVal";
      this.deviceType = "6";
      const data = {
        deviceType: this.deviceType,
        name: this.name,
        emailId: this.emailId,
        otpTYpe: otptype,
        otp: form.value.otp,
      };
      this.backendApiService.postRawRequest("otp", data).subscribe(
        (res: any) => {
          this.spinnerHidden = true;
          // this.response = JSON.parse(res._body). responseCode;
          // console.log(this.response + 'responsre');
          if (res.responseCode === "SC101") {
            this.verify = true;
            this.loginView = false;
            this.forgotPasswordClick = false;
            this.otpView = false;
          }
        },
        (error) => {
          this.spinnerHidden = true;
          this.snackBar.open(
            new DOMParser()
              .parseFromString(error.error, "text/html")
              .getElementsByTagName("p")[1]
              .textContent.replace("message", ""),
            "",
            {
              duration: 2000,
            }
          );
        }
      );
    }
  }

  ngOnInit() {
    this.loginView = true;
    this.forgotPasswordClick = false;
    this.otpView = false;
    this.verify = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts